import { render } from "./AdminAccommodationInquiryDetails.vue?vue&type=template&id=bcdaab12&scoped=true&ts=true"
import script from "./AdminAccommodationInquiryDetails.vue?vue&type=script&lang=ts"
export * from "./AdminAccommodationInquiryDetails.vue?vue&type=script&lang=ts"

import "./AdminAccommodationInquiryDetails.vue?vue&type=style&index=0&id=bcdaab12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcdaab12"]])

export default __exports__